export const iconFontAwesomeHouseholdArrowUpFromWaterPump = (
	<i className="fa-solid fa-arrow-up-from-water-pump"></i>
);
